import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useSmartBack } from '../../hooks/useSmartBack';
import './SmartBackButton.scss';

/**
 * SmartBackButton — user-friendly back button with overlay-first UX.
 *
 * - If a modal/drawer/panel is open, the press closes just that layer.
 * - Otherwise it goes one page back (with a safe fallback for direct
 *   launches with empty history).
 * - 44px touch target, icon + label, accessible by default.
 */
const SmartBackButton = ({
  fallback = '/dashboard',
  label = 'Back',
  className = '',
  variant = 'outline',
  ariaLabel,
  onBeforeBack,
  children,
}) => {
  const { goBack } = useSmartBack(fallback);

  const handleClick = (e) => {
    if (typeof onBeforeBack === 'function' && onBeforeBack(e) === false) return;
    goBack();
  };

  return (
    <button
      type="button"
      className={`smart-back-btn smart-back-btn--${variant} ${className}`.trim()}
      onClick={handleClick}
      aria-label={ariaLabel || label}
    >
      <ArrowLeft size={16} aria-hidden="true" />
      <span>{children || label}</span>
    </button>
  );
};

export default SmartBackButton;
